import { useCallback, useLayoutEffect, useState } from "react";
import { useUserContext } from "../Context/UserContext";
import type { Location } from "./intake";
type Draft = {
  message: string;
  topic: string;
  location: Location;
  creationKey?: string;
  questionId?: string;
  activationMessage?: string;
};
export function useQuestionDraft() {
  const { user } = useUserContext();
  const key =
    user?.id && user.active_org_id
      ? `reviewed.question-draft.${user.id}.${user.active_org_id}`
      : null;
  const [recovered, setRecovered] = useState<Draft | null>(null),
    [saved, setSaved] = useState(true);
  useLayoutEffect(() => {
    setRecovered(null);
    setSaved(true);
    if (!key) return;
    try {
      const d = JSON.parse(sessionStorage.getItem(key) || "null");
      if (
        typeof d?.message === "string" &&
        d.message.length <= 20000 &&
        typeof d.topic === "string" &&
        /^[A-Z]{2}$/.test(d.location?.country) &&
        typeof d.location?.region === "string" &&
        d.at <= Date.now() &&
        Date.now() - d.at < 86400000
      )
        setRecovered(d);
      else sessionStorage.removeItem(key);
    } catch {
      setSaved(false);
    }
  }, [key]);
  const remember = useCallback(
    (draft: Draft) => {
      if (!key) return;
      try {
        if (draft.message) {
          const prior = JSON.parse(sessionStorage.getItem(key) || "null");
          sessionStorage.setItem(
            key,
            JSON.stringify({ ...prior, ...draft, at: Date.now() })
          );
        } else sessionStorage.removeItem(key);
        setSaved(true);
      } catch {
        setSaved(false);
      }
    },
    [key]
  );
  return { recovered, remember, saved, key };
}
